import { render, staticRenderFns } from "./ContactEmail.vue?vue&type=template&id=70e88c53&"
import script from "./ContactEmail.vue?vue&type=script&lang=js&"
export * from "./ContactEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports